import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Home.css";

const DrugDiscovery: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <div className="home-page">
      {/* Hero Section */}
      <div className="hero-section py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h1 className="display-4 fw-bold mb-4">
                Advanced Chemical Structure Analysis with Fyled AI
              </h1>
              <p className="lead mb-4">
                Transform the way you analyze and visualize chemical compounds
                with our cutting-edge AI technology. Draw, upload, and explore
                molecular structures with ease.
              </p>
              <div className="d-flex flex-wrap gap-2">
                <Button
                  variant="primary"
                  size="lg"
                  onClick={() => handleNavigate("/demo")}
                >
                  Try Demo
                </Button>
                {/* <Button
                  variant="outline-primary"
                  size="lg"
                  onClick={() => handleNavigate("/signup")}
                >
                  Get Started
                </Button> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Features Section */}
      <div className="features-section py-5 bg-light">
        <Container>
          <h2 className="text-center mb-5 features-text">Key Features</h2>
          <Row>
            <Col md={4} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Card.Body className="text-center p-4">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-pencil-square fs-1 text-primary"></i>
                  </div>
                  <Card.Title>Draw Compounds</Card.Title>
                  <Card.Text>
                    Interactive molecular editor to draw and visualize chemical
                    structures with ease.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Card.Body className="text-center p-4">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-upload fs-1 text-primary"></i>
                  </div>
                  <Card.Title>Image Upload</Card.Title>
                  <Card.Text>
                    Convert chemical structure images to interactive molecular
                    models with AI-powered recognition.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Card.Body className="text-center p-4">
                  <div className="feature-icon mb-3">
                    <i className="bi bi-file-earmark-pdf fs-1 text-primary"></i>
                  </div>
                  <Card.Title>PDF Analysis</Card.Title>
                  <Card.Text>
                    Extract and analyze chemical structures directly from PDF
                    documents with advanced annotation tools.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default DrugDiscovery;
